<template>
    <div class="dispositivos-convenios">
        <h2>Convenios - Dispositivos Médicos</h2>
        <div class="convenios-content">
            <el-card>
                <div slot="header">
                    <span>Gestión de Convenios de Dispositivos Médicos</span>
                </div>
                <el-table :data="convenios" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="nombre" label="Nombre del Convenio"></el-table-column>
                    <el-table-column prop="proveedor" label="Proveedor"></el-table-column>
                    <el-table-column prop="fechaInicio" label="Fecha de Inicio"></el-table-column>
                    <el-table-column prop="fechaFin" label="Fecha de Fin"></el-table-column>
                    <el-table-column prop="estado" label="Estado"></el-table-column>
                    <el-table-column label="Acciones" width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="editarConvenio(scope.row)">Editar</el-button>
                            <el-button size="mini" type="danger" @click="eliminarConvenio(scope.row)">Eliminar</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosConvenios',
    data() {
        return {
            convenios: [
                { id: 1, nombre: 'Convenio Hospital A', proveedor: 'Proveedor A', fechaInicio: '2024-01-01', fechaFin: '2024-12-31', estado: 'Activo' },
                { id: 2, nombre: 'Convenio Clínica B', proveedor: 'Proveedor B', fechaInicio: '2024-02-01', fechaFin: '2024-11-30', estado: 'Pendiente' },
                { id: 3, nombre: 'Convenio Centro C', proveedor: 'Proveedor C', fechaInicio: '2024-03-01', fechaFin: '2024-10-31', estado: 'Vencido' }
            ]
        }
    },
    methods: {
        editarConvenio(convenio) {
            console.log('Editar convenio:', convenio)
        },
        eliminarConvenio(convenio) {
            console.log('Eliminar convenio:', convenio)
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-convenios {
    padding: 20px;
    
    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }
    
    .convenios-content {
        .el-card {
            margin-bottom: 20px;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);
            
            :deep(.el-card__header) {
                background-color: var(--color-surface-base);
                border-bottom: 1px solid var(--color-border);
                border-radius: var(--radius-md) var(--radius-md) 0 0;
                
                span {
                    color: var(--color-primary);
                    font-weight: 500;
                }
            }
            
            :deep(.el-table) {
                .el-table__header-wrapper {
                    .el-table__header {
                        th {
                            background-color: var(--color-surface-alt);
                            color: var(--color-primary);
                            font-weight: 500;
                        }
                    }
                }
                
                .el-table__body-wrapper {
                    .el-table__body {
                        td {
                            color: var(--color-surface-muted);
                        }
                    }
                }
            }
            
            :deep(.el-button--mini) {
                border-radius: var(--radius-sm);
                
                &.el-button--default {
                    background-color: var(--color-btn-primary);
                    border-color: var(--color-btn-primary);
                    color: white;
                    
                    &:hover {
                        background-color: var(--color-primary-hover);
                        border-color: var(--color-primary-hover);
                    }
                }
                
                &.el-button--danger {
                    background-color: var(--color-btn-danger);
                    border-color: var(--color-btn-danger);
                    
                    &:hover {
                        background-color: var(--color-feedback-error);
                        border-color: var(--color-feedback-error);
                    }
                }
            }
        }
    }
}
</style> 